import script from "./CreateClientForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateClientForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateClientForm.vue?vue&type=style&index=0&id=57898e48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57898e48"]])

export default __exports__